module.exports = __webpack_public_path__ + "img/location.2ce05dd0.png";